import { render, staticRenderFns } from "./ScreenSaver.vue?vue&type=template&id=4c40699a&"
import script from "./ScreenSaver.vue?vue&type=script&lang=ts&"
export * from "./ScreenSaver.vue?vue&type=script&lang=ts&"
import style0 from "./ScreenSaver.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports